// extracted by mini-css-extract-plugin
module.exports = {"header":"scss_header__1vtTK"};